export default __webpack_public_path__ + "static/therealunreal-logo-84a4cf5a244084dc9a97d3cb6a5fd5b8.svg";